module.exports = __webpack_public_path__ + "static/8f9f2c9fdae82706788cf3eb9cee1d9256accfe84c9cae31c7dd837ec77db192-67d8a2bafd3a94ea91d7ad09fb188462.png";